module.exports = __webpack_public_path__ + "assets/img/ability11.1c53be01.png";